export const scrollToHit = hit => {
  if (!hit) return;

  const elem = document.getElementById(hit.objectID);
  if (elem) {
    elem.scrollIntoView();
    window.scrollBy(0, -70);
  }
};
